/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useMemo, useState} from 'react'
import {AktivnePaleteModel} from '../../models/AktivnePaleteModel'
import AktivnePaletaPdf from './AktivnePaletaPdf'
import {pdf} from '@react-pdf/renderer'
import QRCode from 'qrcode'
import {KTIcon} from '../../../_websoft/helpers'



interface Props2 {
    data: AktivnePaleteModel
}

const AktivnePaletaQrCode: FC<Props2> = ({data}) => {
    const [busy, setBusy] = useState(false)

    const filename = useMemo(() => {
        const id = data?.ArtPaletaId ?? 'paleta'
        return `paleta-${id}.pdf`
    }, [data?.ArtPaletaId])

    const handleOpenPdf = async () => {
        if (!data || busy) return

        try {
            setBusy(true)

            // 1) Create QR image (dataURL)
            const qrUrl = await QRCode.toDataURL(
                `${data.ArtPaletaId}; ${data.artikal.ArtNaziv}; Alternativa d.o.o`.toString()
            )

            // 2) Render PDF to Blob (no usePDF hook, no background work per row)
            const blob = await pdf(<AktivnePaletaPdf qrData={data} qrUrl={qrUrl} />).toBlob()

            // 3) Open in new tab
            const url = URL.createObjectURL(blob)
            window.open(url, '_blank', 'noopener,noreferrer')

            // optional cleanup
            setTimeout(() => URL.revokeObjectURL(url), 60_000)
        } catch (e) {
            console.error(e)
            // you can toast here if you want:
            // notifyToast(false, 'Ne mogu generisati PDF.')
        } finally {
            setBusy(false)
        }
    }

    return (
        <button
            type='button'
            className='btn btn-sm btn-light-primary d-inline-flex align-items-center'
            onClick={handleOpenPdf}
            disabled={busy}
            title='Otvori PDF'
        >
            {busy ? (
                <span className='spinner-border spinner-border-sm align-middle' />
            ) : (
                <KTIcon iconName='document' className='fs-2 text-primary' />
            )}
            <span className='ms-2 d-none d-md-inline'>{busy ? 'Generating...' : 'PDF'}</span>
        </button>
    )
}

export default AktivnePaletaQrCode
